import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/opt/atlassian/pipelines/agent/build/platform/services/design-system-docs/src/__DO_NOT_ADD_TO_THIS_FOLDER__/gatsby-theme-brisk/templates/page.tsx";
import typographyGaImageImprovedLegibility from './_images/typography-ga-improved-legibility.png';
import typographyGaImageMetricText from './_images/typography-ga-metric-text.png';
import typographyGaImageGreek from './_images/typography-ga-greek.png';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const Stack = makeShortcode("Stack");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`The Atlassian Design System’s typography system launched in beta in Q3 FY25 and we are excited to
announce `}<strong parentName="p">{`we are officially now in General Availability (GA)`}</strong>{`. This will improve accessibility,
readability, and harmony across apps.`}</p>
    <p>{`Modernized and Legacy typography systems are now deprecated, but will be supported until Jan 2026 to
allow for migrations.`}</p>
    <p>{`All apps are expected to adopt our new typography system using Atlassian Sans and Mono. To make this
process easier, we have enabled the new typography by default in our libraries.`}</p>
    <h2 {...{
      "id": "whats-new-in-ga"
    }}>{`What's new in GA`}</h2>
    <p>{`Since the beta launch, we have focused on refining and enhancing our typography system based on
feedback and testing. These improvements are now available in the General Availability release.`}</p>
    <p>{`Here are the key updates to our typography system:`}</p>
    <Row mdxType="Row">
	<Column size="0.5" mdxType="Column">
		<img src={typographyGaImageImprovedLegibility} borderAppearance="rounded-border" hasMargin={false} />
	</Column>
	<Column mdxType="Column">
		<h4>Improved legibility through character refinement</h4>
		<Stack mdxType="Stack">
			<p>
				Based on legibility testing and user feedback during the beta phase, we have revised the
				design of the lowercase ‘a’ and ‘l’ to enhance readability.
			</p>
			<p>
				We’ve also added true, designed italics styles for both Atlassian Sans and Mono, improving
				the readability and aesthetic quality of italicized text.
			</p>
		</Stack>
	</Column>
    </Row>
    <Row mdxType="Row">
	<Column size="0.5" mdxType="Column">
		<img src={typographyGaImageMetricText} borderAppearance="rounded-border" hasMargin={false} />
	</Column>
	<Column mdxType="Column">
		<h4>Introduction of metric text token and component</h4>
		<p>
			New metric text styles and a component have been implemented to provide a structured and
			consistent approach to managing typography across projects.
		</p>
	</Column>
    </Row>
    <Row mdxType="Row">
	<Column size="0.5" mdxType="Column">
		<img src={typographyGaImageGreek} borderAppearance="rounded-border" hasMargin={false} />
	</Column>
	<Column mdxType="Column">
		<h4>Added language support for Greek</h4>
		<p>
			Support for the Greek language has been added to both Atlassian Sans and Atlassian Mono,
			improving how Greek characters are displayed alongside English and other languages.
		</p>
	</Column>
    </Row>
    <h2 {...{
      "id": "changes-improve-legibility-accessibility-and-consistency"
    }}>{`Changes improve legibility, accessibility, and consistency`}</h2>
    <p>{`The new typography system improves legibility, accessibility and consistency across apps. Here are
some of the specifics of how we got here.`}</p>
    <h3 {...{
      "id": "improved-legibility"
    }}>{`Improved legibility`}</h3>
    <p>{`Feedback from makers and end users revealed legibility issues with the newly-refreshed typography
launched in beta, especially in long-form content.`}</p>
    <ul>
      <li parentName="ul">{`Legibility testing was conducted around letterforms, letter spacing, letter sizing and text
contrast.`}</li>
      <li parentName="ul">{`Results indicated a preference for specific character forms, particularly the double-story 'a' and
'l' without a tail, which improved readability. As a result of this testing, the typography system
has been updated to include these enhancements.`}</li>
    </ul>
    <h3 {...{
      "id": "better-consistency-and-accessibility"
    }}>{`Better consistency and accessibility`}</h3>
    <p>{`A new metric style for displaying numbers in data visualizations has been introduced, available in
three sizes (small, medium, large).`}</p>
    <ul>
      <li parentName="ul">
        <p parentName="li">{`This change addresses previous accessibility issues where makers used headings to highlight key
numeric information. This disrupted the page hierarchy for users of assistive technologies like
screen readers.`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`The new style provides a semantically appropriate way to present numbers, improving the
communication of data and analytics across apps, and enhancing accessibility.`}</p>
        <p parentName="li"><a parentName="p" {...{
            "href": "https://atlassian.design/components/primitives/metric-text/examples"
          }}>{`Metric text examples`}</a></p>
      </li>
    </ul>
    <p><a parentName="p" {...{
        "href": "https://atlassian.design/whats-new/implementing-typography-at-scale"
      }}>{`More about the journey implementing typography at scale`}</a></p>
    <h2 {...{
      "id": "for-atlassians"
    }}>{`For Atlassians`}</h2>
    <p><a parentName="p" {...{
        "href": "https://go.atlassian.com/typography-to-ga"
      }}>{`Migrate to our typography system in code and design`}</a></p>
    <h2 {...{
      "id": "for-marketplace-partners"
    }}>{`For Marketplace partners`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.figma.com/community/file/1527532229258392178/ads-components"
        }}>{`Use the latest community Figma library components`}</a></li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://www.figma.com/community/file/1527530559648073327/ads-foundations"
        }}>{`Use the latest community Figma library foundations`}</a></li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      